import { Component, OnInit, ViewChild, ViewEncapsulation, Output, Input, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { CalendarEvent, CalendarDateFormatter, CalendarView } from 'angular-calendar';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MarketingService } from '../services/marketing.service';
import { Promotion } from '../models/marketing.model';
import { PlacementArray } from 'positioning';
import { CustomDateFormatter } from '../shared/pipes/custom-date-formatter.pipe';
import { NgProgressService } from '../services/ngProgress.service';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }
  ]
})

export class EventsComponent implements OnInit {
  title = 'Events';
  type = 'E';
  selectedDate = new Date();
  eventList: Array<Promotion>;
  selectedEventList: Array<Promotion>;
  view: CalendarView  = CalendarView.Month;
  locale = 'en';
  @Output() viewChange: EventEmitter<string> = new EventEmitter();
  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
  @Input() tooltipPlacement: PlacementArray = 'bottom';
  @Input() tooltipAppendToBody = true;

  viewDate: Date = new Date();

  events: CalendarEvent[] = [];
  refresh: Subject<any> = new Subject();
  showAll: boolean = false;
  loadContent: boolean = false;

  currentUserModel: CurrentUserModel;
  isAU: boolean;

  bannerList: Array<Promotion>;
  selectedBannerList: Array<Promotion>;
  id = 0;
  locationId = 0;
  imageSrc: string;

  constructor(
    private activeRouter: ActivatedRoute,
    private marketingService: MarketingService,
    private ngProgress: NgProgressService,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService,
  ) { }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  
  ngOnInit() {
    this.eventList = new Array<Promotion>();
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.isAU = this.currentUserModel.isAU;
    },
      (error: any) => {
        console.info(error);
      });
    this.ngProgress.start();
    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
      this.marketingService.getPromotionList(this.type).subscribe((value: Array<Promotion>) => {
        this.eventList = value;
        this.selectedEventList = value;
        if (this.eventList) {
          this.eventList.forEach(event => {
            this.events.push({
              title: event.title,
              start: new Date(event.startDate),
              end: new Date(event.expiryDate),
              color: event.virtual ? this.colors.gray : this.colors.red,
              // draggable: true,
              // resizable: {
              //   beforeStart: true,
              //   afterEnd: true
              //}
            });
  
          });
        }
        this.refresh.next();       
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
      });
      const locationId = this.commonService.getBannerLocationId('event');
      this.marketingService.getPromotionList('B', locationId).subscribe((value: Array<Promotion>) => {
        this.bannerList = value;
        this.selectedBannerList = value;
        this.bannerList = value.sort((a, b) => b.id - a.id);
        this.refresh.next();    
        this.ngProgress.done();   
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
      });
    });

    this.ngProgress.done();
  }

  colors: any = {
    gray: {
      primary: '#2F3238',
      secondary: '#2F3238'
    },
    red: {
      primary: '#C20047',
      secondary: '#C20047'
    }
  };

  dayClick(e) {
    this.selectedEventList = [];
    this.showAll = true;
    this.selectedDate = e.day.date;
    e.day.events.forEach(event => {
      if (this.eventList) {
        this.eventList.forEach(ddEvent => {
          var start = new Date(ddEvent.startDate);
          var end = new Date(ddEvent.expiryDate);
          if (start >= event.start && end <= event.end) {
            this.selectedEventList.push(ddEvent);
          }
        });
      }
    });
  }

  showAllEvents() {
    this.showAll = false;
    this.selectedEventList = this.eventList;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  updateEvent(e) {
    //console.log(e);
  }

  clickButton(model: any) {
    //console.log(model);
  }

}
